import { render, staticRenderFns } from "./GroupedMatrixData.vue?vue&type=template&id=b5633c76"
import script from "./GroupedMatrixData.vue?vue&type=script&lang=js"
export * from "./GroupedMatrixData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports